<div class="front-container">
<app-social-contact></app-social-contact>

<h2 class="welcome-title">Welcome to {{siteName}}</h2>
<div class="front-grid">
<div class="welcome">
  <div class="welcome-content">
    <span [innerHTML]="welcomeMessage"></span>
  </div>
</div>

<div class="quick-links">

  <span class="quick-links-group">
    <span class="quick-links-title">About:</span>
    <span class="quick-links-label">
      <a routerLink="/about">About {{siteName}}</a>
    </span>
    <span class="quick-links-separator">&#x25CF;</span>
    <span class="quick-links-label">
      <a routerLink="/documentation">Documentation</a>
    </span>
  </span>

  <span class="quick-links-group">
    <span class="quick-links-title">Tools:</span>
    <span class="quick-links-label">
      <a routerLink="/query"
         title="Query genes with the Advanced Search tool">Advanced search</a>
    </span>
    <span class="quick-links-separator">&#x25CF;</span>
    <span *ngIf="siteName == 'JaponicusDB'">
      <a href="/jbrowse/" target="_blank"
         title="View genome-wide datasets the JBrowse genome browser">
        Genome browser
      </a>
    </span>
    <span *ngIf="siteName == 'PomBase' || siteName == 'FlyQuery'">
      <a routerLink="/gocam">GO-CAM pathways</a>
    </span>
  </span>

  <span class="quick-links-group">
    <span class="quick-links-line">
      <span class="quick-links-title">Example pages:</span>
      <span class="quick-links-label"><a routerLink="/gene/{{examplePages.gene}}">Gene</a></span>
      <span class="quick-links-separator">&#x25CF;</span>
      <span class="quick-links-label"><a routerLink="/term/{{examplePages.term}}">Term</a></span>
      <span class="quick-links-separator">&#x25CF;</span>
      <span class="quick-links-label"><a routerLink="/reference/{{examplePages.reference}}">Publication</a></span>
      <span *ngIf="examplePages.gocam" class="quick-links-separator">&#x25CF;</span>
      <span *ngIf="examplePages.gocam" class="quick-links-label">
        <a routerLink="/gocam/pombase-view/docs/{{examplePages.gocam}}">Pathway</a>
      </span>
    </span>
  </span>

</div>

<div class="welcome-logos">
  <div class="gcbr-elixir-logo-row">
  <span *ngIf="showElixirAndGbcLogos">
    <span class="gcbr-elixir-logo">
      <a href="https://globalbiodata.org/scientific-activities/global-core-biodata-resources/"
         title="{{siteName}} is a GBC Global Core Biodata Resource">
        <img src="assets/GCBR-Logo-RGB.svg">
      </a>
    </span>
    <span class="gcbr-elixir-logo">
      <a href="https://elixir-europe.org/platforms/data/core-data-resources"
         title="{{siteName}} is an ELIXIR Core Data Resource">
        <img src="assets/elixir-core-data-resources-logo.png">
      </a>
    </span>
  </span>
  <div class="mod-link-logo" *ngIf="siteName == 'PomBase'">
    <a href="https://www.japonicusdb.org" title="Visit JaponicusDB">
      <div>
      <img src="assets/japonicusdb/apple-icon-57x57.png"/>
      JaponicusDB
      </div>
    </a>
  </div>
  <div class="mod-link-logo" *ngIf="siteName == 'JaponicusDB'">
    <a href="https://www.pombase.org" title="Visit PomBase">
      <div>
      <img src="assets/pombase/apple-icon-57x57.png"/>
      PomBase
      </div>
    </a>
  </div>
  </div>
</div>

<div *ngIf="frontBoxConf" class="front-right">
  <div *ngIf="siteName == 'PomBase' || siteName == 'JaponicusDB'"
       class="bs-callout bs-callout-info front-right-row front-info-box">
    <details>
      <summary>
        <span [innerHTML]="frontBoxConf.summary"></span>
        <div><a class="summary-details">details ...</a></div>
      </summary>
      <ng-component [innerHTML]="frontBoxConf.details" class="front-info-box-content"></ng-component>
    </details>
  </div>
</div>

  <div class="front-panel info-panel spotlight">
    <app-front-panel *ngIf="spotlightConf" [panelType]="'spotlight'"
                     [conf]="spotlightConf"></app-front-panel>
    <div class="archive-link-container">
    <a routerLink="/archive/spotlight">View more Community Curation spotlights ...</a>
    </div>
  </div>

  <div class="front-panel info-panel explore">
    <app-front-panel *ngIf="exploreConf" [panelType]="'explore'"
                     [conf]="exploreConf"></app-front-panel>
    <div class="archive-link-container">
      <a routerLink="/archive/explore">View more {{siteName}} features ...</a>
    </div>
  </div>

  <div class="front-panel info-panel community">
    <div class="community front-panel">
      <div class="panel-contents">
        <div class="title">
          Recent community curation
        </div>
        <app-recent-community-pubs></app-recent-community-pubs>
      </div>
    </div>
    <div class="archive-link-container">
      <a routerLink="/reference_list/community">All community curation ...</a>
    </div>
    <div *ngIf="hasAdminCuration" class="archive-link-container">
      <a routerLink="/reference_list/admin">{{siteName}} staff curated publications ...</a>
    </div>
  </div>

  <div class="front-panel info-panel pombetalks">
    <a routerLink="/community/pombetalks">
      <img src="assets/pombetalks-panel-image.png"/>
      <div class="panel-title">
        <div>
          pombeTalks - Talks by and for the fission yeast community
        </div>
        <div>
          View upcoming talk dates and speakers ...
        </div>
      </div>
    </a>
  </div>

  <div *ngIf="showNewsItems" class="front-news-feed">
    <div class="font-news-archive"><a routerLink="/news">News archive ...</a></div>
    <h3 class="front-page-list-title">Recent news</h3>
    <app-recent-news></app-recent-news>
  </div>

</div>
</div>

<hr style="clear: both" />

<div class="metadata" *ngIf="metadata">
  <div>Database created: {{metadata.db_creation_datetime}}</div>
  <div class="pombase-chado-json">Database v{{metadata.date_version}} generated by {{metadata.export_prog_name}} v{{metadata.export_prog_version}}</div>
</div>
